import { render } from "./TopNavBar.vue?vue&type=template&id=036e01aa&scoped=true&ts=true"
import script from "./TopNavBar.vue?vue&type=script&lang=ts"
export * from "./TopNavBar.vue?vue&type=script&lang=ts"

import "./TopNavBar.vue?vue&type=style&index=0&id=036e01aa&scoped=true&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/Dashboard_HV/Dashboard_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036e01aa"]])

export default __exports__